import * as requests from './requests'
import constants from './constants'
import urls from './urls'

// Departamento

export async function getDepartamentos() {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, urls.GET_DEPARTAMENTOS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getDepartamentoById(payload) {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, `${urls.GET_DEPARTAMENTO_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateDepartamento(payload) {
  return requests
    .put(constants.API_URL_USUARIOS_MANAGER, urls.PUT_DEPARTAMENTO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertDepartamento(payload) {
  return requests
    .post(constants.API_URL_USUARIOS_MANAGER, urls.POST_DEPARTAMENTO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteDepartamento(payload) {
  return requests
    .remove(constants.API_URL_USUARIOS_MANAGER, `${urls.DELETE_DEPARTAMENTO_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// USUARIOS

export async function getUsuariosTree() {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, urls.GET_USUARIOS_TREE)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUsuariosTreeFiltered(payload) {
  return requests
    .post(constants.API_URL_USUARIOS_MANAGER, urls.GET_USUARIOS_TREE_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUsuarios() {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, urls.GET_USUARIOS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUsuarioById(payload) {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, `${urls.GET_USUARIO_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUsuarioPerfilById(payload) {
  const overrideUserId = import.meta.env.VITE_FORCE_USUARIO_PROD_ID

  if (overrideUserId)
    payload = overrideUserId

  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, `${urls.GET_USUARIO_PERFIL_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getUsuarioStockManager() {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, urls.GET_USUARIO_STOCK_MANAGER)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateUsuario(payload) {
  return requests
    .putForm(constants.API_URL_USUARIOS_MANAGER, urls.PUT_USUARIO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function patchUsuario(id, payload) {
  return requests
    .jsonPatch(constants.API_URL_USUARIOS_MANAGER, `${urls.PATCH_USUARIO_UPDATE}/${id}`, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertUsuario(payload) {
  return requests
    .postForm(constants.API_URL_USUARIOS_MANAGER, urls.POST_USUARIO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteUsuario(payload) {
  return requests
    .remove(constants.API_URL_USUARIOS_MANAGER, `${urls.DELETE_USUARIO_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function cambiarPassUsuario(payload) {
  return requests
    .patch(constants.API_URL_USUARIOS_MANAGER, urls.PATCH_CAMBIAR_PASS_USUARIO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function establcerImagenUsuario(payload) {
  return requests
    .patchForm(constants.API_URL_USUARIOS_MANAGER, urls.PATCH_CAMBIAR_IMAGEN_USUARIO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Estados de Usuario

export async function getEstadosUsuarios() {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, urls.GET_ESTADOS_USUARIOS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getEstadoUsuarioById(payload) {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, `${urls.GET_ESTADO_USUARIO_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateEstadoUsuario(payload) {
  return requests
    .put(constants.API_URL_USUARIOS_MANAGER, urls.PUT_ESTADO_USUARIO_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function inserEstadoUsuario(payload) {
  return requests
    .post(constants.API_URL_USUARIOS_MANAGER, urls.POST_ESTADO_USUARIO_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteEstadoUsuario(payload) {
  return requests
    .remove(constants.API_URL_USUARIOS_MANAGER, `${urls.DELETE_ESTADO_USUARIO_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Roles

export async function getListadoRoles() {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, urls.GET_ROLES_LISTA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getRolById(id) {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, `${urls.GET_ROLES_BY_ID}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getRolesFiltered(payload) {
  return requests
    .post(constants.API_URL_USUARIOS_MANAGER, urls.GET_ROLES_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertarRol(payload) {
  return requests
    .post(constants.API_URL_USUARIOS_MANAGER, urls.POST_ROLES_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateRol(payload) {
  return requests
    .put(constants.API_URL_USUARIOS_MANAGER, urls.PUT_ROLES_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteRol(payload) {
  return requests
    .remove(constants.API_URL_USUARIOS_MANAGER, `${urls.DELETE_ROLES_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function setRolMenus(payload) {
  return requests
    .put(constants.API_URL_USUARIOS_MANAGER, urls.POST_ROLES_SET_MENUS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Menus

export async function geListadoMenusAdmin() {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, urls.GET_MENU_ADMIN_ALL)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Roles Usuario

export async function getPermisosUsuarios(id) {
  const overrideUserId = import.meta.env.VITE_FORCE_USUARIO_PROD_ID

  if (overrideUserId)
    id = overrideUserId
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, `${urls.GET_PERMISOS_USUARIOS}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function setPermisosUsuarios(payload) {
  return requests
    .post(constants.API_URL_USUARIOS_MANAGER, urls.POST_PERMISOS_USUARIOS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getPermisosMenuUsuarios(id) {
  const overrideUserId = import.meta.env.VITE_FORCE_USUARIO_PROD_ID

  if (overrideUserId)
    id = overrideUserId
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, `${urls.GET_PERMISOS_USUARIOS_MENU}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getPermisosMenuKeyUsuario(id) {
  const overrideUserId = import.meta.env.VITE_FORCE_USUARIO_PROD_ID

  if (overrideUserId)
    id = overrideUserId
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, `${urls.GET_PERMISOS_USUARIOS_MENUKEY}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Firewall IP

export async function getListadoFirewallIps() {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, urls.GET_FIREWALLIPS_LISTA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertFirewallIp(payload) {
  return requests
    .post(constants.API_URL_USUARIOS_MANAGER, urls.POST_FIREWALLIPS_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFirewallIp(payload) {
  return requests
    .remove(constants.API_URL_USUARIOS_MANAGER, `${urls.DELETE_FIREWALLIPS_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getIpRemotaFirewallIps() {
  return requests
    .get(constants.API_URL_USUARIOS_MANAGER, urls.GET_FIREWALLIPS_IP_REMOTA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
